(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollHideThreshold = 8;
      this.headerInteractionSuspendUntil = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.bindMenuDrawerInteraction();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.menuDrawerSummary?.removeEventListener('pointerdown', this.onMenuDrawerInteraction);
      this.menuDrawerSummary?.removeEventListener('touchstart', this.onMenuDrawerInteraction);
      this.menuDrawerSummary?.removeEventListener('focus', this.onMenuDrawerInteraction);
      this.menuDrawerSummary?.removeEventListener('click', this.onMenuDrawerInteraction);
      this.menuDrawerDetails?.removeEventListener('toggle', this.onMenuDrawerToggle);
      window.clearTimeout(this.resumeHeaderHideTimer);
      window.cancelAnimationFrame(this.pendingHeaderFrame);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (Math.abs(scrollDelta) < this.scrollHideThreshold) return;
      if (Date.now() < this.headerInteractionSuspendUntil) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.queueHeaderChange(this.hide.bind(this));
      } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.queueHeaderChange(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.queueHeaderChange(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.queueHeaderChange(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    queueHeaderChange(callback) {
      window.cancelAnimationFrame(this.pendingHeaderFrame);
      this.pendingHeaderFrame = requestAnimationFrame(callback);
    }

    bindMenuDrawerInteraction() {
      this.menuDrawerSummary = this.querySelector('#Details-menu-drawer-container > summary');
      this.menuDrawerDetails = this.querySelector('#Details-menu-drawer-container');
      if (!this.menuDrawerSummary || !this.menuDrawerDetails) return;

      this.onMenuDrawerInteraction = () => this.suspendHeaderHideForMenu();
      this.onMenuDrawerToggle = () => {
        if (this.menuDrawerDetails.open) {
          this.suspendHeaderHideForMenu();
        } else {
          window.clearTimeout(this.resumeHeaderHideTimer);
          this.preventHide = false;
          this.header.style.top = '';
          this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        }
      };

      this.menuDrawerSummary.addEventListener('pointerdown', this.onMenuDrawerInteraction);
      this.menuDrawerSummary.addEventListener('touchstart', this.onMenuDrawerInteraction, { passive: true });
      this.menuDrawerSummary.addEventListener('focus', this.onMenuDrawerInteraction);
      this.menuDrawerSummary.addEventListener('click', this.onMenuDrawerInteraction);
      this.menuDrawerDetails.addEventListener('toggle', this.onMenuDrawerToggle);
    }

    suspendHeaderHideForMenu() {
      this.headerInteractionSuspendUntil = Date.now() + 900;
      this.preventReveal = false;
      this.preventHide = true;
      window.clearTimeout(this.isScrolling);
      window.clearTimeout(this.resumeHeaderHideTimer);
      window.cancelAnimationFrame(this.pendingHeaderFrame);
      this.reveal();
      this.header.style.top = '0';
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.resumeHeaderHideTimer = setTimeout(() => {
        if (!this.header.classList.contains('menu-open')) {
          this.header.style.top = '';
          this.preventHide = false;
        }
      }, 900);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
